import React, { Component } from "react";

import {
  Button,
  Col,
  Input,
  InputNumber,
  Modal,
  Row,
  Radio,
  Select,
  Table,
  notification,
} from "antd";

import { Controller } from "Controller/Controller";

import { Alert } from "components/Alert/Alert";
import { BsClockHistory } from "react-icons/bs";
const { Search } = Input;
const { TextArea } = Input;
const { Option } = Select;

const serviceColumns = [
  /*{
    title: 'Id',
    dataIndex: 'Id',
    render: text => <a>{text}</a>,
  },*/
  {
    title: "Name",
    dataIndex: "Name",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Count",
    dataIndex: "Count",
    render: (text) => <a>{text}</a>,
  },
  /*  {
      title: 'Price',
      dataIndex: 'Price',
      render: text => <a>{text}</a>,
    },*/
  {
    title: "Action",
    dataIndex: "Action",
    render: (text) => <a>{text}</a>,
  },
];

class CreatePlan extends Component {
  openNotification = (placement, message, status) => {
    notification.info({
      message: status,
      description: message,
      placement,
    });
  };

  getPlan = async () => {
    const response = await Controller.GetAllPlans();
    this.setState({
      planList: response.json,
    });
  };

  getCycle = async () => {
    const response = await Controller.getCycles();
    console.log("response.json");
    console.log(response.json);
    this.setState({
      Cycle: response.json,
    });
  };

  getMember = async () => {
    const response = await Controller.GetAllMember();
    console.log("response.json");
    this.setState({
      membersList: response.json,
    });
  };

  handleCloseMember = () => {
    this.setState({
      openCreateMember: false,
    });
  };

  handleAddNewMember = (id) => {
    console.log(id);
    this.getMember();

    this.setState({
      newCustomerid: id,
      openCreateMember: false,
    });
  };

  handleAddMember = () => {
    this.setState({
      openCreateMember: true,
    });
  };

  getData = () => {
    // get billing cycle
    this.getCycle();

    //Get member list
    this.getMember();

    //Get Plan list
    this.getPlan();
  };

  setServicesFromProps = (row) => {
    var temp = [];
    console.log("asdasd");
    for (var i in row.services) {
      console.log(i);
      temp.push({
        Count: row.services[i].count,
        Name: row.services[i].service,
        Id: row.services[i].id,
      });
    }
    console.log(temp);
    this.setState({
      selectedServices: temp,
      changeStateTempForTestTableUpdate:
        !this.state.changeStateTempForTestTableUpdate,
    });
  };

  mapRepeatTypeToInterval = (type) => {
    switch (type) {
      case "day":
        return "Daily";
      case "week":
        return "Weekly";
      case "month":
        return "Monthly";
      case "year":
        return "Annual";
      default:
        return "Monthly";
    }
  };

  constructor(props) {
    super(props);

    //this.getData();

    console.log(props);

    this.state = {
      loading: false,
      row: props.editRow,
      newCustomerid: "",
      openCreateMember: false,
      repeatCounts: {
        day: 1,
        week: 1,
        month: 1,
        year: 1,
      },
      membershipCreateDataCustom: {
        membership: {
          customer: 0,
          is_active: true,
          automatic_renewal: false,
        },
        membership_plan: {
          services: [],
          name: "",
          interval: "",
          interval_count: 0,
          active: true,
          cost: "",
          description: "",
          type: "custom",
          terms: "",
        },
      },
      membershipCreateData: {
        customer: "",
        plan: "",
        automatic_renewal: false,
      },
      changeStateTempForTestTableUpdate: true,
      showCreateServiceForm: false,
      SelectedServicesFromSelectBox: "",
      SelectedCountFromSelectBox: "",
      preDefinePlanForCreate: {
        name: "",
        interval: "",
        interval_count: 0,
        cost: "",
        description: "",
        active: true,
        clinic: localStorage.getItem("selectedOffice"),
        type: "predefined",
        services: [
          /*{
            count: 0,
            service: 0
          }*/
        ],
        terms: "",
      },
      createsService: {
        name: "",
        description: "",
        cost: 0,
      },
      NpServices: [
        {
          cost: "",
          description: "",
          id: 1,
          name: "",
        },
      ],
      openAddNewRowVisible: false,
      membersList: [],
      Cycle: [],
      planList: [],
      visibleAddservice: false,
      selectedServices: [
        {
          Name: "1",
          Count: "1",
        },
      ],
      currentState: "createNewPlan", // 1. customePlan 2. preDefinePlan 3.createNewPlan
    };

    /*
     */

    //this.setServicesFromProps(props.editRow)
    this.updateServiceList = this.updateServiceList.bind(this);
    this.setServicesFromProps = this.setServicesFromProps.bind(this);
    this.handleAddNewMember = this.handleAddNewMember.bind(this);
    this.handleCreateCustomPlan = this.handleCreateCustomPlan.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);
    this.getCycle = this.getCycle.bind(this);
    this.getData = this.getData.bind(this);
    this.getPlan = this.getPlan.bind(this);
    this.handleOpenAddService = this.handleOpenAddService.bind(this);
    this.handleCloseAddService = this.handleCloseAddService.bind(this);
    this.addNewRow = this.addNewRow.bind(this);
    this.addNewRowModal = this.addNewRowModal.bind(this);
    this.handleCreateNewPlan = this.handleCreateNewPlan.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.editService = this.editService.bind(this);
    this.handleCreateService = this.handleCreateService.bind(this);
    this.handleChangeCreatePlanData =
      this.handleChangeCreatePlanData.bind(this);
    this.handleCreateNewPlanPreDefined01 =
      this.handleCreateNewPlanPreDefined01.bind(this);
    //this.handleSelectMemberInModal = this.handleSelectMemberInModal.bind(this)
    this.handleSubmitCreateNewMembershipWithMemberAndPlan =
      this.handleSubmitCreateNewMembershipWithMemberAndPlan.bind(this);
  }

  // componentDidMount() {
  //   var temp = [];
  //   console.log("asdasd");
  //   for (var i in this.props.editRow.services) {
  //     console.log(i);
  //     temp.push({
  //       Count: this.props.editRow.services[i].count,
  //       Name: this.props.editRow.services[i].service,
  //       id: this.props.editRow.services[i].id,
  //       Action: (
  //         <button
  //           onClick={() => {
  //             var aaaa = this.state.selectedServices.filter(
  //               (e) => e.id != this.props.editRow.services[i].id
  //             );
  //             console.log(aaaa);
  //             this.setState({
  //               selectedServices: aaaa,
  //             });
  //           }}
  //           value={this.state.selectedServices.length}
  //           style={{
  //             border: "0px",
  //             backgroundColor: "transparent",
  //             color: "#0981C8",
  //           }}
  //         >
  //           Delete
  //         </button>
  //       ),
  //     });
  //   }
  //   console.log(temp);
  //   this.setState({
  //     selectedServices: temp,
  //     changeStateTempForTestTableUpdate:
  //       !this.state.changeStateTempForTestTableUpdate,
  //   });
  // }

  componentDidMount() {
    var temp = [];
    console.log("asdasd");
    for (var i in this.props.editRow.services) {
      console.log(i);

      const item = this.props.editRow.services[i];
      const capturedRowId = item.id;
      const capturedServiceId = item.service_id || item.id;

      temp.push({
        Count: item.count,
        Name: item.service,
        id: capturedRowId,
        Action: (
          <button
            onClick={() => {
              var aaaa = (this.state.selectedServices || []).filter(
                (e) => String(e.id) !== String(capturedRowId)
              );
              console.log(aaaa);

              const updatedRowServices = (
                this.state.row?.services || []
              ).filter(
                (s) => String(s.service_id) !== String(capturedServiceId)
              );

              this.setState({
                selectedServices: aaaa,
                row: {
                  ...this.state.row,
                  services: updatedRowServices,
                },
              });
            }}
            value={this.state.selectedServices.length}
            style={{
              border: "0px",
              backgroundColor: "transparent",
              color: "#0981C8",
            }}
          >
            Delete
          </button>
        ),
      });
    }
    console.log(temp);
    this.setState({
      selectedServices: temp,
      changeStateTempForTestTableUpdate:
        !this.state.changeStateTempForTestTableUpdate,
    });
  }

  updateServiceList = async () => {
    const response = await Controller.GetServiceNP(
      this.state.currentState !== "customePlan" ? "membership" : "installment"
    );

    this.setState({
      NpServices: response.json,
    });
  };

  editService = async () => {
    let payload = {
      id: this.state.SelectedServicesFromSelectBox,
      ...this.state.createsService,
    };

    if (!payload.name || payload.name.trim() === "") {
      Alert.openNotification("Please enter a service name", "error");
      return null;
    }
    if (
      payload.cost === "" ||
      payload.cost === null ||
      isNaN(Number(payload.cost))
    ) {
      Alert.openNotification("Please enter a valid cost", "error");
      return null;
    }

    const isInstallment = this.state.currentState === "customePlan";
    if (!isInstallment) {
      if (!payload.interval || !payload.interval_count) {
        Alert.openNotification(
          "Please set the replenish schedule (interval)",
          "error"
        );
        return null;
      }
      payload = { ...payload, type: "membership" };
    } else {
      // delete payload.interval;
      // delete payload.interval_count;
      payload = { ...payload, type: "installment" };
    }

    payload.cost = Number(payload.cost);

    // console.log(data)
    const response = await Controller.EditService(payload);

    if (response.status < 250) {
      await this.updateServiceList();
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
    } else {
      Alert.openNotification(
        response.json.detail ? response.json.detail : "Error",
        "error"
      );
    }
    // handleCloseEdit()
  };

  handleRepeatCountChange = (type, value) => {
    this.setState((prevState) => {
      const newCounts = {
        ...prevState.repeatCounts,
        [type]: value,
      };

      const newState = {
        repeatCounts: newCounts,
      };

      // Update createsService only if this is the active type
      if (prevState.repeatType === type) {
        newState.createsService = {
          ...prevState.createsService,
          interval_count: value,
        };
      }

      return newState;
    });
  };

  handleCreateCustomPlan = async () => {
    console.log(this.state.membershipCreateDataCustom);

    const response = await Controller.CreateCustomMembership(
      this.state.membershipCreateDataCustom
    );
    console.log(response);
    if (response.status < 250) {
      this.openNotification(
        "bottom",
        response.message ? response.message : "Done",
        "Successfull"
      );
      this.setState({
        membershipCreateDataCustom: {
          ...this.state.membershipCreateDataCustom,
          membership_plan: {
            ...this.state.membershipCreateDataCustom.membership_plan,
            services: [],
            name: "",

            interval_count: 0,
            active: true,
            cost: "",
            description: "",
            type: "custom",
            terms: "",
          },
        },
      });
    }
  };

  handleSubmitCreateNewMembershipWithMemberAndPlan = async () => {
    const response = await Controller.CreateMembershipnPreDefined(
      this.state.membershipCreateData
    );
    if (response.status < 250) {
      this.setState({
        membershipCreateData: {
          ...this.state.membershipCreateData,
          plan: "",
        },
      });
      this.openNotification(
        "bottom",
        response.message ? response.message : "Done",
        "Successfull"
      );
    }
  };

  handleCloseAddRowModal = () => {
    this.setState({
      openAddNewRowVisible: false,
      SelectedServicesFromSelectBox: "",
      SelectedCountFromSelectBox: "",
      showCreateServiceForm: false,
      visibleAddservice: false,
    });
  };

  addNewRowModal = async () => {
    const response = await Controller.GetServiceNP();

    this.setState({
      openAddNewRowVisible: true,
      NpServices: response.json,
    });
  };

  handleSelectExistingService = (id) => {
    const svc = (this.state.NpServices || []).find((s) => s.id == id);
    console.log(svc);

    const toRepeatType = (interval) => {
      if (!interval) return undefined;
      const v = String(interval).toLowerCase();
      if (v === "daily") return "day";
      if (v === "weekly") return "week";
      if (v === "monthly") return "month";
      if (v === "annual") return "year";
      return undefined;
    };

    const repeatType = toRepeatType(svc?.interval);

    const planServices =
      this.state.currentState === "customePlan"
        ? this.state.membershipCreateDataCustom?.membership_plan?.services || []
        : this.state.preDefinePlanForCreate?.services || [];

    const existingRow = planServices.find(
      (row) => String(row.service) === String(id)
    );

    const prevCount = Number(
      existingRow && existingRow.count != null ? existingRow.count : 1
    );

    const hasExpire =
      !!existingRow &&
      !!existingRow.duration_unit &&
      existingRow.duration_unit !== "";
    const expirationType = hasExpire
      ? String(existingRow.duration_unit)
      : "none";
    const duration_unit = hasExpire ? String(existingRow.duration_unit) : "";
    const duration_value = hasExpire
      ? Number(existingRow.duration_value)
      : null;

    this.setState((prev) => ({
      SelectedServicesFromSelectBox: id,
      showCreateServiceForm: true,
      isExistingService: true,
      isEditingExistingService: true,

      createsService: {
        ...prev.createsService,
        name: svc?.name ?? "",
        description: svc?.description ?? "",
        cost: svc?.cost ?? 0,
        interval: svc?.interval,
        interval_count: svc?.interval_count ?? 1,
      },

      SelectedCountFromSelectBox: prevCount,
      expirationType,
      duration_unit,
      duration_value,

      repeatType: repeatType ?? prev.repeatType,
      repeatCounts: repeatType
        ? { ...prev.repeatCounts, [repeatType]: svc?.interval_count ?? 1 }
        : prev.repeatCounts,
    }));
  };

  handleCreateService = async () => {
    const response = await Controller.CreateServiceList(
      this.state.createsService
    );
    if (response.status < 250) {
      // ADDED: refresh the list so the new item appears
      await this.updateServiceList();

      // ADDED: select the newly created service id so Save can attach it
      this.setState({
        SelectedServicesFromSelectBox:
          response?.json?.id ?? this.state.SelectedServicesFromSelectBox,
        createsService: {
          name: "",
          description: "",
          cost: 0,
        },
      });

      this.openNotification(
        "bottom",
        "Create service successful",
        "successful"
      );
      this.handleCloseAddService();

      return response; // ADDED
    } else {
      this.openNotification(
        "bottom",
        response.detail ? response.detail : "Error!",
        "Error"
      );
      return response; // ADDED
    }
  };

  handleCreateNewPlanPreDefined01 = async () => {
    this.setState({ loading: true });

    const temp = [];
    for (let i in this.state.row.services) {
      if (this.state.row.services[i].unit_price) {
        temp.push({
          count: this.state.row.services[i].count,
          service: this.state.row.services[i].service_id,
        });
      }
    }

    if (temp.length === 0) {
      Alert.openNotification(
        "You must add at least one service to update this plan.",
        "error"
      );
      this.setState({ loading: false });
      return;
    }

    const response = await Controller.EditMembershipPlan(
      {
        services: temp,
        name: this.state.row.name,
        interval: this.state.row.interval,
        active: true,
        cost: this.state.row.cost,
        description: "",
        terms: this.state.row.terms,
      },
      this.state.row.id,
      this.state.row.office.id
    );

    if (response.status < 250) {
      this.setState({
        selectedServices: [],
        preDefinePlanForCreate: {
          name: "",
          interval: "",
          interval_count: 0,
          cost: "",
          description: "",
          active: true,
          clinic: localStorage.getItem("selectedOffice"),
          type: "predefined",
          services: [],
          terms: "",
        },
      });
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );
      this.props.handleDoneEdit();
    } else {
      let errorMessage = "Error";
      if (response.json?.detail) {
        errorMessage = response.json.detail;
      } else {
        errorMessage = response.json.services
          ? "Service : " + response.json.services
          : response.json.name
          ? "Plan Name : " + response.json.name
          : response.json.active
          ? "Active : " + response.json.active
          : response.json.cost
          ? "Cost : " + response.json.cost
          : response.json.description
          ? "Description : " + response.json.description
          : response.json.terms
          ? "Term : " + response.json.terms
          : response.message || "Error";
      }
      Alert.openNotification(errorMessage, "error");
    }

    this.setState({ loading: false });
  };

  handleChangeCreatePlanData(e) {
    const { name, value } = e.target;
    this.setState({
      row: {
        ...this.state.row,
        [name]: value,
      },
    });
  }

  handleChange(e) {
    console.log(e.target);
    const { name, value } = e.target;
    console.log(name);
    console.log(value);
    this.setState({
      createsService: {
        ...this.state.createsService,
        [name]: value,
      },
    });
  }

  handleCreateNewPlan = () => {
    this.setState({
      currentState: "createNewPlan",
    });
  };

  addNewRow = async () => {
    var temp = this.state.selectedServices;
    const response = await Controller.GetServiceNP();
    temp.push({
      Id: this.state.selectedServices.length,
      Name: (
        <Select
          className="inputs"
          style={{ minWidth: "100px" }}
          placeholder="Select Service"
          defaultValue={[]}
          onChange={(e, value) => {
            console.log(this.state.services);
            console.log(e);
            this.setState({
              preDefinePlanForCreate: {
                ...this.state.preDefinePlanForCreate,
                services: this.state.preDefinePlanForCreate.services.push(e),
              },
            });
          }}
        >
          {response.json.map((service) => (
            <Option key={service.id}>{service.name}</Option>
          ))}
        </Select>
      ),
      Count: (
        <InputNumber
          defaultValue={0}
          min={0}
          //max={10}
          formatter={(value) => `${value}x`}
          parser={(value) => value.replace("x", "")}
          //onChange={onChange}
        />
      ),
      Price: <p>$ 0</p>,
      Action: (
        <button
          value={this.state.selectedServices.length}
          onClick={(e) => {
            e.preventDefault();
            console.log(e.target.value);
            /*console.log(this.state.selectedServices)
            var temp = this.state.selectedServices
            console.log(temp)
            console.log(e.target.value)*/
            var temp = this.state.selectedServices.filter(
              (t) => t.Id != e.target.value
            );
            if (temp.length < 1) {
              this.setState({
                selectedServices: [],
              });
            } else {
              console.log(temp);
              this.setState({
                selectedServices: temp,
              });
            }
          }}
          style={{
            border: "0px",
            backgroundColor: "transparent",
            color: "#0981C8",
          }}
        >
          Delete
        </button>
      ),
    });

    this.setState({
      selectedServices: temp,
      changeStateTempForTestTableUpdate:
        !this.state.changeStateTempForTestTableUpdate,
    });
  };

  handleChangeCurrentState = (e) => {
    this.setState({ currentState: e.target.value });
  };

  handleOpenAddService = () => {
    this.setState({
      visibleAddservice: true,
      showCreateServiceForm: true,

      isExistingService: false,
      isEditingExistingService: false,

      SelectedServicesFromSelectBox: "",

      createsService: {
        name: "",
        description: "",
        cost: 0,

        interval: undefined,
        interval_count: 1,
      },

      SelectedCountFromSelectBox: 1,

      repeatType: undefined,
      repeatCounts: {
        day: 1,
        week: 1,
        month: 1,
        year: 1,
      },

      expirationType: "none",
      duration_unit: "",
      duration_value: null,
    });
  };

  handleCloseAddService = () => {
    this.setState({
      createsService: {
        name: "",
        description: "",
        cost: 0,
      },
      visibleAddservice: false,
    });
  };

  handleDateChange(value, dateString) {
    this.setState({
      ...this.state,
      appointment_datetime: dateString,
    });
  }

  render() {
    const readOnlyExisting =
      this.state.showCreateServiceForm &&
      this.state.isEditingExistingService === true;
    //const { currentState } = this.state;
    return (
      <div className="paymentRequestContent" style={{ width: "100%" }}>
        <div className="payreq-container">
          <div className="content">
            <React.Fragment>
              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Plan name
              </label>
              <Input
                //prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                className={"inputs"}
                onChange={this.handleChangeCreatePlanData}
                type="text"
                name="name"
                placeholder="plan #1"
                value={this.state.row.name}
              />

              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Billing Cycle
              </label>
              <Select
                className="inputs"
                style={{ minWidth: "100px" }}
                defaultValue={[]}
                placeholder="Select Cycle"
                name="interval"
                value={this.state.row.interval ? this.state.row.interval : null}
                onChange={(e, value) => {
                  this.setState({
                    row: {
                      ...this.state.row,
                      interval: e,
                    },
                  });
                }}
              >
                {this.state.Cycle &&
                  this.state.Cycle.map((cycle) => (
                    <>
                      <Option key={cycle}>{cycle}</Option>
                    </>
                  ))}
              </Select>

              {/*<label style={{ margin: "10px 0px 5px 0px" }} className='formLabel'>Commitment Term</label>
              <Input
                prefix={<BsClockHistory style={{ color: 'rgba(0,0,0,.25)' }} />}
                name="interval_count"
                className={"inputs"}
                onChange={this.handleChangeCreatePlanData}
                type="text"

                placeholder="Commitment Term"
                value={this.state.row.interval_count}
              /> */}

              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Price
              </label>
              <InputNumber
                value={this.state.row.cost}
                defaultValue={0}
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                style={{ width: "100%" }}
                onChange={(e) => {
                  this.setState({
                    row: {
                      ...this.state.row,
                      cost: e,
                    },
                  });
                }}
              />

              <br />
              <br />
              <Row type="flex" justify="space-between">
                <label>
                  Service{" "}
                  {/*<span
                        style={{ cursor: "pointer" }}
                        onClick={
                          //this.addNewRow
                          this.addNewRowModal
                        }>+</span>*/}
                </label>
                <Button
                  //onClick={this.handleOpenAddService}
                  onClick={
                    //this.addNewRow
                    this.addNewRowModal
                  }
                  type="primary"
                  style={{ marginBottom: 16 }}
                >
                  + New
                </Button>
              </Row>
              {this.state.changeStateTempForTestTableUpdate ? (
                <Table
                  style={{
                    width: "auto",
                    overflow: "auto",
                  }}
                  Pagination={false}
                  columns={serviceColumns}
                  dataSource={this.state.selectedServices}
                />
              ) : (
                <div>
                  <Table
                    style={{
                      width: "auto",
                      overflow: "auto",
                    }}
                    Pagination={false}
                    columns={serviceColumns}
                    dataSource={this.state.selectedServices}
                  />
                </div>
              )}

              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Terms
              </label>

              <TextArea
                name="terms"
                value={this.state.row.terms}
                onChange={(e) => {
                  //console.log(e.target.value)
                  this.setState({
                    row: {
                      ...this.state.row,
                      terms: e.target.value,
                    },
                  });
                }}
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder="Write Terms..."
              />

              <Row
                justify="end"
                style={{ marginTop: "25px", padding: "8px" }}
                gutter={[16]}
              >
                <Button
                  onClick={this.handleCreateNewPlanPreDefined01}
                  style={{ width: "100%" }}
                  type="primary"
                  disabled={this.state.loading}
                >
                  {this.state.loading ? "Updating..." : "Update"}
                </Button>
              </Row>
              <Row justify="end" style={{ padding: "8px" }} gutter={[16]}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => {
                    console.log(this.props);
                    this.props.handleBackEdit();
                  }}
                >
                  Back
                </Button>
              </Row>
            </React.Fragment>

            <br />
          </div>
        </div>

        {/*---------------------------Add new service-------------------------*/}

        <Modal
          title="Add new service"
          visible={this.state.openAddNewRowVisible}
          footer={null}
          //onOk={this.handleOk}
          onCancel={this.handleCloseAddRowModal}
        >
          {!this.state.showCreateServiceForm && (
            <>
              <label className="formLabel">Service</label>
              <Row type="flex" justify="space-between">
                <Col span={18}>
                  <Select
                    className="inputs"
                    style={{ minWidth: "100px" }}
                    placeholder="Select Service"
                    value={
                      this.state.SelectedServicesFromSelectBox
                        ? this.state.SelectedServicesFromSelectBox
                        : undefined
                    }
                    onChange={this.handleSelectExistingService}
                  >
                    {this.state.NpServices.map((service) => (
                      <Option key={service.id}>{service.name}</Option>
                    ))}
                  </Select>
                </Col>
                <Col span={5}>
                  <Button
                    onClick={this.handleOpenAddService}
                    /*onClick={
                    //this.addNewRow
                    this.addNewRowModal
                  }*/
                    type="primary"
                    style={{ marginBottom: 16 }}
                  >
                    Add Service
                  </Button>
                </Col>
              </Row>
            </>
          )}

          {this.state.showCreateServiceForm && (
            <div className="addService">
              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Service Name
              </label>

              <Input
                className={"inputs"}
                onChange={this.handleChange}
                type="text"
                name="name"
                placeholder="Service 1"
                value={this.state.createsService.name}
                disabled={readOnlyExisting}
              />

              {(this.state.showCreateServiceForm ||
                this.state.SelectedServicesFromSelectBox) && (
                <>
                  <br />
                  Count
                  <br />
                  <InputNumber
                    style={{ width: "100%" }}
                    defaultValue={0}
                    min={0}
                    //max={10}
                    value={this.state.SelectedCountFromSelectBox}
                    formatter={(value) => `${value}x`}
                    parser={(value) => value.replace("x", "")}
                    onChange={(e) => {
                      this.setState({
                        SelectedCountFromSelectBox: e,
                      });
                      //console.log(e)
                    }}
                  />
                  <br />
                </>
              )}

              {/* <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Cost
              </label>
              <InputNumber
                value={this.state.createsService.cost}
                name="cost"
                defaultValue={0}
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                style={{ width: "100%" }}
                onChange={(e, value) => {
                  console.log(e);

                  this.setState({
                    createsService: {
                      ...this.state.createsService,
                      cost: e,
                    },
                  });
                }}
              /> */}
              {/* Interval and Interval Count Fields */}
              <>
                {/* Replaced Billing Interval with Radio Group */}
                <label className="formLabel" style={{ marginTop: 10 }}>
                  Services Will Be Replenished:
                </label>
                <div style={{ margin: "10px 0" }}>
                  <Radio.Group
                    value={this.state.repeatType}
                    disabled={readOnlyExisting}
                    onChange={(e) => {
                      const newType = e.target.value;
                      this.setState({
                        repeatType: newType,
                        createsService: {
                          ...this.state.createsService,
                          interval: this.mapRepeatTypeToInterval(newType),
                          interval_count: this.state.repeatCounts[newType],
                        },
                      });
                    }}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Radio
                      value="day"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.day}
                        onChange={(value) =>
                          this.handleRepeatCountChange("day", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "day" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      day
                    </Radio>

                    <Radio
                      value="week"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.week}
                        onChange={(value) =>
                          this.handleRepeatCountChange("week", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "week" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      week
                    </Radio>

                    <Radio
                      value="month"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.month}
                        onChange={(value) =>
                          this.handleRepeatCountChange("month", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "month" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      month
                    </Radio>

                    <Radio
                      value="year"
                      style={{ marginBottom: 8, alignItems: "center" }}
                    >
                      Every{" "}
                      <InputNumber
                        min={1}
                        value={this.state.repeatCounts.year}
                        onChange={(value) =>
                          this.handleRepeatCountChange("year", value)
                        }
                        bordered={false}
                        controls={false}
                        disabled={
                          this.state.repeatType !== "year" || readOnlyExisting
                        }
                        style={{
                          width: "70px",
                          textAlign: "center",
                          borderBottom: "1px solid #000",
                          background: "transparent",
                          padding: 0,
                        }}
                      />{" "}
                      year
                    </Radio>
                  </Radio.Group>
                </div>
              </>

              <label
                style={{ margin: "10px 0px 5px 0px" }}
                className="formLabel"
              >
                Description
              </label>

              <TextArea
                name="description"
                value={this.state.createsService.description}
                onChange={this.handleChange}
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder="Description..."
                disabled={readOnlyExisting}
              />
              <br />
              <div
                className="btnBox"
                style={{ display: "flex", justifyContent: "end" }}
              >
                {/* <Button onClick={this.handleCloseAddService} type="secondary">
                  Close
                </Button> */}
                {/* <Button
                  onClick={this.handleCreateService}
                  type="primary"
                  style={{ marginLeft: "5px" }}
                >
                  Create
                </Button> */}
              </div>
            </div>
          )}
          <div
            style={{
              marginTop: "15px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Button
              onClick={() => {
                if (
                  this.state.showCreateServiceForm ||
                  this.state.visibleAddservice
                ) {
                  this.handleCloseAddService();
                }
                this.handleCloseAddRowModal();
              }}
              type="secondary"
            >
              Close
            </Button>

            <Button
              type="primary"
              style={{ marginLeft: "5px" }}
              disabled={
                !this.state.SelectedServicesFromSelectBox &&
                !this.state.showCreateServiceForm
              }
              onClick={async () => {
                const createdNameFallback = this.state.createsService?.name;

                // capture id if we create a brand-new service now
                let createdId;

                // If inline form is open, make sure the service exists (create or edit)
                if (this.state.showCreateServiceForm) {
                  if (this.state.isExistingService) {
                    await this.editService();
                  } else {
                    // Create brand-new service if no id selected yet
                    if (!this.state.SelectedServicesFromSelectBox) {
                      const createResp = await this.handleCreateService(); // returns response
                      if (!createResp || createResp.status >= 250) {
                        return; // stop on error
                      }
                      createdId = createResp?.json?.id;
                    }
                  }
                }

                // Prepare expiration fields
                const { expirationType, duration_unit, duration_value } =
                  this.state;
                const durationUnit =
                  expirationType === "none" ? null : duration_unit;
                const durationValue =
                  expirationType === "none" ? null : duration_value;

                // Resolve selected service id (prefer selection, else the created one)
                const selectedServiceId =
                  this.state.SelectedServicesFromSelectBox || createdId;

                if (!selectedServiceId) {
                  return; // nothing to attach
                }

                const selectedInList =
                  (this.state.NpServices || []).find(
                    (s) => String(s.id) === String(selectedServiceId)
                  ) || null;

                // Duplicate protection against the rendered table list
                const alreadyExists = (this.state.selectedServices || []).some(
                  (s) => String(s.id) === String(selectedServiceId)
                );

                // If we were editing and it's already attached, just close the modal
                if (alreadyExists && this.state.isEditingExistingService) {
                  this.handleCloseAddRowModal();
                  return;
                }

                if (alreadyExists && !this.state.isEditingExistingService) {
                  Alert.openNotification(
                    "This service is already available in the list",
                    "error"
                  );
                  return;
                }

                // Build payloads to attach
                const newServiceData = {
                  count:
                    Number(this.state.SelectedCountFromSelectBox) > 0
                      ? Number(this.state.SelectedCountFromSelectBox)
                      : 1,
                  service: selectedServiceId,
                  duration_unit: durationUnit,
                  duration_value: durationValue,
                };

                const newTableRow = {
                  id: selectedServiceId,
                  Name: selectedInList
                    ? selectedInList.name
                    : createdNameFallback || "Service",
                  Count:
                    Number(this.state.SelectedCountFromSelectBox) > 0
                      ? Number(this.state.SelectedCountFromSelectBox)
                      : 1,
                  DurationUnit: durationUnit,
                  DurationValue: durationValue,
                  Action: (
                    <button
                      onClick={() => {
                        const updatedSelected = (
                          this.state.selectedServices || []
                        ).filter(
                          (e) => String(e.id) !== String(selectedServiceId)
                        );
                        const updatedPreDefine = (
                          this.state.preDefinePlanForCreate.services || []
                        ).filter(
                          (e) => String(e.service) !== String(selectedServiceId)
                        );
                        const updatedCustom = (
                          this.state.membershipCreateDataCustom.membership_plan
                            .services || []
                        ).filter(
                          (e) => String(e.service) !== String(selectedServiceId)
                        );
                        const updatedRowServices = (
                          this.state.row?.services || []
                        ).filter(
                          (s) =>
                            String(s.service_id) !== String(selectedServiceId)
                        );
                        this.setState({
                          selectedServices: updatedSelected,
                          preDefinePlanForCreate: {
                            ...this.state.preDefinePlanForCreate,
                            services: updatedPreDefine,
                          },
                          membershipCreateDataCustom: {
                            ...this.state.membershipCreateDataCustom,
                            membership_plan: {
                              ...this.state.membershipCreateDataCustom
                                .membership_plan,
                              services: updatedCustom,
                            },
                          },
                          row: {
                            ...this.state.row,
                            services: updatedRowServices,
                          },
                        });
                      }}
                      style={{
                        border: "0px",
                        backgroundColor: "transparent",
                        color: "#0981C8",
                      }}
                    >
                      Delete
                    </button>
                  ),
                };

                this.setState((prev) => ({
                  // keep predefined list in sync
                  preDefinePlanForCreate: {
                    ...prev.preDefinePlanForCreate,
                    services: [
                      ...prev.preDefinePlanForCreate.services,
                      newServiceData,
                    ],
                  },
                  // FIX: append to the existing custom plan list (not preDefinePlan list)
                  membershipCreateDataCustom: {
                    ...prev.membershipCreateDataCustom,
                    membership_plan: {
                      ...prev.membershipCreateDataCustom.membership_plan,
                      services: [
                        ...(prev.membershipCreateDataCustom.membership_plan
                          .services || []),
                        newServiceData,
                      ],
                    },
                  },
                  // update rendered table
                  selectedServices: [...prev.selectedServices, newTableRow],
                  changeStateTempForTestTableUpdate:
                    !prev.changeStateTempForTestTableUpdate,
                  row: {
                    ...prev.row,
                    services: [
                      ...(prev.row?.services || []).filter(
                        (s) =>
                          String(s.service_id) !== String(selectedServiceId)
                      ),

                      {
                        service_id: selectedServiceId,
                        count:
                          Number(prev.SelectedCountFromSelectBox) > 0
                            ? Number(prev.SelectedCountFromSelectBox)
                            : 1,

                        unit_price: true,
                      },
                    ],
                  },
                }));

                // Close modal
                this.handleCloseAddRowModal();
              }}
            >
              Save
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default CreatePlan;
